import { render, staticRenderFns } from "./ReportChat.vue?vue&type=template&id=905f8538&"
import script from "./ReportChat.vue?vue&type=script&lang=js&"
export * from "./ReportChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports